import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import './PanelCardHeader.css';

interface PanelCardHeaderProps {
  title: string;
  onRemove?: () => void;
  showRemove?: boolean;
  rightSlot?: React.ReactNode;
  className?: string;
}

const PanelCardHeader: React.FC<PanelCardHeaderProps> = ({
  title,
  onRemove,
  showRemove = true,
  rightSlot,
  className
}) => {
  const stopDragStart = (e: React.MouseEvent | React.TouchEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className={`panel-header panel-card-header-drag-handle ${className ?? ''}`}
      title={title}
    >
      <div className="panel-title" title={title}>
        {title}
      </div>

      <div className="panel-header-actions">
        {rightSlot}

        {showRemove && onRemove && (
          <Button
            variant="outline-danger"
            size="sm"
            className="panel-remove-btn"
            onMouseDown={stopDragStart}
            onTouchStart={stopDragStart}
            onClick={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            aria-label="Remove panel"
            title="Remove"
          >
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        )}
      </div>
    </div>
  );
};

export default PanelCardHeader;
